// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';

// Styles
import './ballot-checker.scss';
import BallotService from '../../redux/services/ballot';
import { getPrettyDate } from '../../common/utils/date-utils';

class BallotCheckerPage extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            validAccessToken: true,
            memberData: null
        };
    }

    componentDidMount() {
        let search = window.location.search;       
        let urlParams = new URLSearchParams(search);

        this.validateTokenIdentifier(urlParams);
    }

    validateTokenIdentifier(urlParams) {
        let tokenIdentifier = urlParams.get('q');
        
        if(tokenIdentifier !== null) {
            BallotService.getBallotStatus(tokenIdentifier)
            .then((response) => {
                this.setState({
                    memberData: {
                        photo: response.photo || null,
                        name: response.name || null,
                        professionalName: response.professionalName || null,
                        ballotRef: response.ballotRef || null,
                        nif: response.nif || null,
                        active: response.active ?? null,
                        admissionDate: response.admissionDate || null,
                        dueDate: response.dueDate || null
                    }
                });
            })
            .catch(error => {
                window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
            });
        }
        else {
            window.open(process.env.REACT_APP_OF_SITE_URL,"_self");
        }
    }

    render() {
        const { memberData } = this.state;

        const photo = memberData?.photo || null;
        const name = memberData?.name || null;
        const professionalName = memberData?.professionalName || null;
        const ballotRef = memberData?.ballotRef || null;
        const nif = memberData?.nif || null;
        const isActive = memberData?.active ?? null;
        const admissionDate = memberData?.admissionDate ? getPrettyDate(memberData.admissionDate) : null;
        const dueDate = memberData?.dueDate ? getPrettyDate(memberData.dueDate) : null;

        return (
            this.state.validAccessToken === true ?
                <div className="ballot-checker-page">
                    <div className="id-card">
                        <div className="id-card-header">
                            <img src={`${process.env.PUBLIC_URL}/assets/ordem-fisioterapeutas-logo.png`} alt="Ordem dos Fisioterapeutas" />
                            <span className="id-card-header-title">Cédula Profissional</span>
                        </div>

                        {isActive === false ? (
                            <div className="id-card-inactive-body">
                                <p>
                                    Os dados do Fisioterapeuta não se encontram disponíveis. Por favor consulte a página{' '}
                                    <a href="https://ordemdosfisioterapeutas.pt/pt/encontre-um-fisioterapeuta/" target="_blank" rel="noopener noreferrer">
                                        Encontre o Fisioterapeuta
                                    </a>.
                                </p>
                            </div>
                        ) : (
                            <>
                                <div className="id-card-body">
                                    <div className="id-card-avatar">
                                        <div className="avatar-circle">
                                            {photo
                                                ? <img src={`data:image/jpeg;base64,${photo}`} alt="Foto" />
                                                : <i className="pi pi-user" />
                                            }
                                        </div>
                                    </div>

                                    <div className="id-card-fields">

                                        <div className="id-card-field text-left">
                                            <span className="id-card-field-label">Nome</span>
                                            <span className={`id-card-field-value${!name ? ' placeholder' : ''}`}>
                                                {name || '—'}
                                            </span>
                                        </div>

                                        <div className="id-card-field text-left names-bottom-border">
                                            <span className="id-card-field-label">Nome Profissional</span>
                                            <span className={`id-card-field-value${!professionalName ? ' placeholder' : ''}`}>
                                                {professionalName || '—'}
                                            </span>
                                        </div>

                                        <div className="id-card-field-row">
                                            <div className="id-card-field text-left">
                                                <span className="id-card-field-label">Nº Cédula</span>
                                                <span className={`id-card-field-value${!ballotRef ? ' placeholder' : ''}`}>
                                                    {ballotRef || '—'}
                                                </span>
                                            </div>

                                            <div className="id-card-field text-left">
                                                <span className="id-card-field-label">NIF</span>
                                                <span className={`id-card-field-value${!nif ? ' placeholder' : ''}`}>
                                                    {nif || '—'}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="id-card-field-row">
                                            <div className="id-card-field text-left">
                                                <span className="id-card-field-label">Data de Admissão</span>
                                                <span className={`id-card-field-value${!admissionDate ? ' placeholder' : ''}`}>
                                                    {admissionDate || '—'}
                                                </span>
                                            </div>

                                            <div className="id-card-field text-left">
                                                <span className="id-card-field-label">Validade</span>
                                                <span className={`id-card-field-value${!dueDate ? ' placeholder' : ''}`}>
                                                    {dueDate || '—'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {isActive !== null && (
                                    <div className="id-card-footer">
                                        <span className={`id-card-badge${!isActive ? ' inactive' : ''}`} />
                                        <span>{isActive ? 'Ativo' : 'Inativo'}</span>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            : null
        );
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
    }
};

export default connect(undefined, mapDispatchToProps)(withTranslation(BallotCheckerPage));